module.exports = __webpack_public_path__ + "static/media/bestseller.e8da2058.png";